// Improvements are welcome!
/**
 *
 * @param queryString
 * @returns parsed query string in object form
 * @example "?foo=bar" returns { foo: 'bar' }
 */
export default function parseQueryString(queryString = '', replacePlusWithSpace = true): Record<string, string> {
  if (queryString === '') {
    return {};
  }

  const queryObj: Record<string, string> = {};
  let pieces: string | Array<string> = queryString;

  if (pieces.startsWith('?')) {
    pieces = pieces.split('?')[1];
  }
  pieces = pieces.split('&');

  pieces.forEach(function (piece) {
    const sliceIndex = piece.indexOf('='); //get index of first "="
    const name = piece.slice(0, sliceIndex);
    const value = piece.slice(sliceIndex + 1);

    try {
      const decodedComponent = decodeURIComponent(value);
      queryObj[name] = replacePlusWithSpace ? decodedComponent.replace(/\+/g, ' ') : decodedComponent;
    } catch {
      // const errorMsg = `ERROR @ queryUtils.parse: ${error}`;
      // NewRelicService.dispatch({
      //     message: errorMsg,
      //     context: 'queryUtils.parse'
      // });
    }
  });

  return queryObj;
}
